import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../firebase-config";
import { Typography, Box, Stack, Button } from "@mui/material";
import * as XLSX from "xlsx";

function Row(props) {
  const { total, name, currency } = props;

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell component="th" scope="row">
          {name}
        </TableCell>
        <TableCell align="right">
          {currency}. {total.toLocaleString()}
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function CashFlow({
  id,
  year,
  period,
  company_name,
  periodIndex,
}) {
  const [dataId, setDataId] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);

  const tableRef = React.useRef(null);

  /* Callback invoked when the button is clicked */
  const xport = React.useCallback(async () => {
    /* Create worksheet from HTML DOM TABLE */
    // const table = document.getElementById("Table2XLSX");
    const table = tableRef.current;
    const wb = XLSX.utils.table_to_book(table);

    /* Export to file (start a download) */
    XLSX.writeFile(wb, `Cash Flow ${company_name} ${period} ${year}.xlsx`);
  }, [company_name, period, year]);

  async function getCashFlow({ id, year, period, periodIndex }) {
    setLoading(true);
    const q = query(
      collection(db, "companies-financials"),
      where("company-id", "==", id),
      where("year", "==", year),
      where("type", "==", "Cash Flow"),
      where("period", "==", period),
      where("period-index", "==", periodIndex)
    );
    let idDoc;
    const allDocs = [];
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      allDocs.push(doc.data());
      idDoc = doc.id;
    });
    setData(allDocs[0]);
    setDataId(idDoc);
    setLoading(false);
  }

  useEffect(() => {
    getCashFlow({ id, year, period, periodIndex });
  }, [id, period, year, periodIndex]);

  return loading ? (
    <h1>Loading</h1>
  ) : data === undefined ? (
    <Typography>No Data Available</Typography>
  ) : (
    <>
      {!process.env.NODE_ENV || process.env.NODE_ENV === "development" ? (
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          <Typography>{dataId}</Typography>
        </Stack>
      ) : (
        <></>
      )}
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="flex-start"
        spacing={2}
      >
        <Button
          variant="outlined"
          onClick={xport}
          size="small"
          color="secondary"
        >
          Export to Excel
        </Button>
      </Stack>

      <Box
        sx={{
          marginBottom: "10px",
        }}
      />
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table" ref={tableRef}>
          <TableHead
            sx={{
              backgroundColor: "black",
            }}
          >
            <TableRow>
              {/* <TableCell /> */}
              <TableCell>Breakdown</TableCell>
              <TableCell align="right">{year}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data["Operating Cash Flow"] !== undefined ? (
              <Row
                name="Operating Cash Flow"
                key="Operating Cash Flow"
                total={data["Operating Cash Flow"]}
                currency={data["currency"]}
              />
            ) : (
              <></>
            )}
            {data["Investing Cash Flow"] !== undefined ? (
              <Row
                name="Investing Cash Flow"
                key="Investing Cash Flow"
                total={data["Investing Cash Flow"]}
                currency={data["currency"]}
              />
            ) : (
              <></>
            )}
            {data["Financing Cash Flow"] !== undefined ? (
              <Row
                name="Financing Cash Flow"
                key="Financing Cash Flow"
                total={data["Financing Cash Flow"]}
                currency={data["currency"]}
              />
            ) : (
              <></>
            )}

            {data["Net Change In Cash"] !== undefined ? (
              <Row
                name="Net Change In Cash"
                key="Net Change In Cash"
                total={data["Net Change In Cash"]}
                currency={data["currency"]}
              />
            ) : (
              <></>
            )}

            {data["End Cash Position"] !== undefined ? (
              <Row
                name="End Cash Position"
                key="End Cash Position"
                total={data["End Cash Position"]}
                currency={data["currency"]}
              />
            ) : (
              <></>
            )}

            {data["Free Cash Flow"] !== undefined ? (
              <Row
                name="Free Cash Flow"
                key="Free Cash Flow"
                total={data["Free Cash Flow"]}
                currency={data["currency"]}
              />
            ) : (
              <></>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
